import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'upsc-privacy-notice',
  templateUrl: './privacy-notice.component.html',
  styleUrls: ['./privacy-notice.component.scss']
})
export class PrivacyNoticeComponent implements OnInit {

  ngOnInit(): void {
  }
}